import { FC, memo } from 'react';
import { StatisticsSectionsTable } from '../../StatisticsV2/shared/StatisticsSectionsTable/StatisticsSectionsTable';
import { InboundStatisticRow } from './buildIncomingStatisticRows';

interface Props {
  dataSource: InboundStatisticRow[];
  loading?: boolean;
  sectionModes?: Readonly<Record<string, string>>;
  onSectionModeChange?: (sectionKey: string, mode: string) => void;
}

export const IncomingStatistics: FC<Props> = memo(
  ({
    dataSource,
    loading = false,
    sectionModes,
    onSectionModeChange,
  }: Props) => {
    return (
      <StatisticsSectionsTable
        dataSource={dataSource}
        loading={loading}
        displayName="IncomingStatistics"
        sectionModes={sectionModes}
        onSectionModeChange={onSectionModeChange}
      />
    );
  },
);

IncomingStatistics.displayName = 'IncomingStatistics';
